import React from "react";
import { Form, Image } from "react-bootstrap";
import classnames from "classnames";
import Switch from "react-switch";
import {
  ReusableOnboardingMapButton,
  ReusableOnboardingButton,
} from "../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import SuggestNewButton from "../../../reusableOnboardingPopupComponent/suggestNew/SuggestNewButton";
import InputNumberFunc from "../../../../../function/InputNumberFunc";
import { InputBoxComponent } from "../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import { ReservationTimeModel } from "../../../reusableOnboardingPopupComponent/ReservationTimeModel";
import RightSidePannel from "../../rightSidePannelReusable/RightSidePannel";
// import MultipleImageUploadComponent from "../../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";

export const SeatingArea = ({
  displayScreen,
  onSeatingChangeHandler,
  state,
  onLocatedInsideArraySelector,
  onDrop,
  onClickDisplayScreen,
  onClickDisplayScreenClosed,
  handleChangehighchair,
  handleChangehandicapAccess,
  handleChangeroomNumberSeatingRequest,
  handleChangetableManagement,
  tableManagement,
  onFocusOut,
  onChange,
  errors,
  reservationTableAroundTimeOpen,
  reservationTableAroundTimeClosed,
  reservationTableAroundTimeTextButtonClick,
  seatingCapacity,
  autoAcceptPaxLimit,
  seatingAreaScreenNext,
  children,
}) => {
  return (
    <React.Fragment>
      <div className="seating-area-section">
        {displayScreen === false ? (
          <div>
            <div className="col-12 onboarding-back-button-all-screen">
              <div
                className="back_button-link"
                onClick={onSeatingChangeHandler}
              >
                <Image
                  src={require("../../../../../assets/images/Icon/onBoardBack.png")}
                  alt="Back Button"
                  title="Back Button"
                />
              </div>
            </div>
            <div className="display-toggle-stepup-button">
              <RightSidePannel selectedTab={4} />
            </div>
            <div>
              <TopTextReusableComponent headingText="Seating Area" />
            </div>
            <div className="top-seating-area-heading">
              <h4 className="big-heading-text">Where is your seating area?</h4>
              <p className="small-heading-text">
                (Please include all the seating areas in your food facility)
              </p>
            </div>
            <div className="restaurant_type_onboarding_main margin-bottom-chains-onboarding">
              <div>
                <div className="cuisine-main ">
                  <div
                    className={
                      state.all_seating_area.length > 8
                        ? "cuisine-main-padding-border"
                        : ""
                    }
                  >
                    <div
                      id="box-style"
                      className="cuisine-main-padding"
                      style={{ display: "flex", flexWrap: "wrap" }}
                    >
                      {state.all_seating_area.map((icon, index) => (
                        <ReusableOnboardingMapButton
                          key={index}
                          classsection={
                            state.selected_seating_area.some(
                              (icons) => icons._id === icon._id
                            )
                              ? // state.selected_seating_area.includes(icon)
                                "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_activesingle"
                              : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                          }
                          src={icon.icon}
                          title={icon.title}
                          onClick={onLocatedInsideArraySelector(icon)}
                        />
                      ))}
                    </div>
                  </div>
                  <div className="suggest-button-heading">
                    <SuggestNewButton categoryId={"5f5723f455e36968b805b4cb"} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 p-0 mb-md-5 mb-lg-5 mb-xl-5 margin-bottom-chains-onboarding">
              {/* <MultipleImageUploadComponent
                title="Upload Documents"
                smallTitle="(Upload supporting documents for PAN, GST, FSSAI and a
              Cancelled Cheque as applicable)"
                onDrop={onDrop}
                imageExtension={[".jpg", ".gif", ".png", ".jpeg"]}
              /> */}
              {children}
            </div>
            <div className="onboarding-map-setup-screen-autodetect-button">
              {/* <div className="onboarding-map-setup-screen-autodetect-button-inside"> */}
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                buttonText="Back"
                onClick={onSeatingChangeHandler}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass={
                  state.selected_seating_area.length <= 0
                    ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                    : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                }
                disabled={
                  state.selected_seating_area.length <= 0 ? true : false
                }
                buttonText="Next"
                buttonType="button"
                onClick={onClickDisplayScreen}
              />
            </div>
          </div>
        ) : (
          <div>
            <div className="col-12 onboarding-back-button-all-screen">
              <div
                className="back_button-link"
                onClick={onClickDisplayScreenClosed}
              >
                <Image
                  src={require("../../../../../assets/images/Icon/onBoardBack.png")}
                  alt="Back Button"
                  title="Back Button"
                />
              </div>
            </div>
            <div className="display-toggle-stepup-button">
              <RightSidePannel selectedTab={4} />
            </div>
            <div>
              <TopTextReusableComponent headingText="Seating General Settings" />
            </div>
            <div className="top-seating-area-heading mb-3">
              <h4 className="big-heading-text">
                Do you provide services for the following?
              </h4>
              <div className="highchair-subscription-new">
                <div>
                  <h5>Highchair</h5>
                  <div className="d-flex align-items-center">
                    <p
                      className={
                        state.highchair === false
                          ? "toggleclass-button-yes-no-button-active"
                          : "toggleclass-button-yes-no-button"
                      }
                    >
                      No
                    </p>
                    <Switch
                      checked={state.highchair}
                      onChange={handleChangehighchair}
                      onColor="#59f832"
                      onHandleColor="#ffffff"
                      handleDiameter={23}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={26}
                      width={55}
                      className="toggle-button-margin"
                      id="material-switch"
                    />
                    <p
                      className={
                        state.highchair === false
                          ? "toggleclass-button-yes-no-button"
                          : "toggleclass-button-yes-no-button-active"
                      }
                    >
                      Yes
                    </p>
                  </div>
                </div>
                <div>
                  <h5>Handicap Access</h5>
                  <div className="d-flex align-items-center">
                    <p
                      className={
                        state.handicapAccess === false
                          ? "toggleclass-button-yes-no-button-active"
                          : "toggleclass-button-yes-no-button"
                      }
                    >
                      No
                    </p>
                    <Switch
                      checked={state.handicapAccess}
                      onChange={handleChangehandicapAccess}
                      onColor="#59f832"
                      onHandleColor="#ffffff"
                      handleDiameter={23}
                      uncheckedIcon={false}
                      checkedIcon={false}
                      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                      height={26}
                      width={55}
                      className="toggle-button-margin"
                      id="material-switch"
                    />
                    <p
                      className={
                        state.handicapAccess === false
                          ? "toggleclass-button-yes-no-button"
                          : "toggleclass-button-yes-no-button-active"
                      }
                    >
                      Yes
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="top-seating-area-heading mb-3">
              <h4 className="big-heading-text">
                Room number on Seating Request?
              </h4>
            </div>
            <div className="d-flex align-items-center">
              <p
                className={
                  state.roomNumberSeatingRequest === false
                    ? "toggleclass-button-yes-no-button-active"
                    : "toggleclass-button-yes-no-button"
                }
              >
                No
              </p>
              <Switch
                checked={state.roomNumberSeatingRequest}
                onChange={handleChangeroomNumberSeatingRequest}
                onColor="#59f832"
                onHandleColor="#ffffff"
                handleDiameter={23}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={26}
                width={55}
                className="toggle-button-margin"
                id="material-switch"
              />
              <p
                className={
                  state.roomNumberSeatingRequest === false
                    ? "toggleclass-button-yes-no-button"
                    : "toggleclass-button-yes-no-button-active"
                }
              >
                Yes
              </p>
            </div>
            <div className="top-seating-area-heading mb-3">
              <h4 className="big-heading-text">Do you use table management?</h4>
              <p className="small-heading-text">
                (If you use any software or option to manage your tables)
              </p>
            </div>
            <div className="d-flex align-items-center">
              <p
                className={
                  state.tableManagement === false
                    ? "toggleclass-button-yes-no-button-active"
                    : "toggleclass-button-yes-no-button"
                }
              >
                No
              </p>
              <Switch
                checked={state.tableManagement}
                onChange={handleChangetableManagement}
                onColor="#59f832"
                onHandleColor="#ffffff"
                handleDiameter={23}
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                height={26}
                width={55}
                className="toggle-button-margin"
                id="material-switch"
              />
              <p
                className={
                  state.tableManagement === false
                    ? "toggleclass-button-yes-no-button"
                    : "toggleclass-button-yes-no-button-active"
                }
              >
                Yes
              </p>
            </div>
            <div className="col-12 custom-height-seating-genral-one">
              <div className="row align-items-center">
                <div className="col-7 col-sm-7 col-md-6 col-lg-5 col-xl-5 pl-0">
                  <div className="top-seating-area-heading">
                    <h4 className="big-heading-text">Seating Capacity</h4>
                    <p className="small-heading-text">
                      (Total Seating capacity No. of People)
                    </p>
                  </div>
                </div>
                <div className="col-5 col-sm-5 col-md-6 col-lg-4 col-xl-4 pr-0">
                  <div>
                    <div className="position-relative">
                      <InputBoxComponent
                        displayLabel={false}
                        controlId="seatingCapacity"
                        placeHolder="eg. 60*"
                        name="seatingCapacity"
                        maxLength="4"
                        inputType="number"
                        onChange={onChange}
                        onFocusOut={onFocusOut}
                        value={state.seatingCapacity}
                        onKeyDown={InputNumberFunc}
                        required="required"
                        // error={errors.seatingCapacity}
                        inputClassName={classnames(
                          "input-component-inputfield text-center pr-4",
                          {
                            invalid: errors.seatingCapacity,
                          }
                        )}
                      />
                      <p className="small-bottom-text-input-seatingarea">pax</p>
                      <Form.Text className="w-100 text-muted text-center input-component-bottom position-absolute">
                        <div className="text-danger text-capitalize">
                          {errors.seatingCapacity ===
                          "seatingCapacity is required"
                            ? "seating capacity is required"
                            : null}
                        </div>
                      </Form.Text>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 custom-height-seating-genral-one">
              <div className="row align-items-center">
                <div className="col-7 col-sm-7 col-md-6 col-lg-5 col-xl-5 pl-0">
                  <div className="top-seating-area-heading">
                    <h4 className="big-heading-text">Auto accept Pax Limit</h4>
                    <p className="small-heading-text">
                      (Request with pax below this will automati cally be
                      accepted for seating, any number above this threshold will
                      go to pending for action)
                    </p>
                  </div>
                </div>
                <div className="col-5 col-sm-5 col-md-6 col-lg-4 col-xl-4 pr-0">
                  <div>
                    <div className="position-relative">
                      <InputBoxComponent
                        displayLabel={false}
                        controlId="autoAcceptPaxLimit"
                        placeHolder="eg. 6*"
                        name="autoAcceptPaxLimit"
                        maxLength="2"
                        inputType="number"
                        onChange={onChange}
                        onFocusOut={onFocusOut}
                        value={state.autoAcceptPaxLimit}
                        onKeyDown={InputNumberFunc}
                        required="required"
                        inputClassName={classnames(
                          "input-component-inputfield text-center pr-4",
                          {
                            invalid: errors.autoAcceptPaxLimit,
                          }
                        )}
                      />
                      <p className="small-bottom-text-input-seatingarea">pax</p>
                      <Form.Text className="w-100 text-muted text-center input-component-bottom position-absolute">
                        <div className="text-danger text-capitalize">
                          {errors.autoAcceptPaxLimit ===
                          "autoAcceptPaxLimit is required"
                            ? "auto Accept Pax Limit is required"
                            : null}
                        </div>
                      </Form.Text>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-12 custom-height-seating-genral-one margin-bottom-chains-onboarding">
              <div className="row align-items-center">
                <div className="col-7 col-sm-7 col-md-6 col-lg-5 col-xl-5 pl-0">
                  <div className="top-seating-area-heading">
                    <h4 className="big-heading-text">
                      Table turn Around Time?
                    </h4>
                    <p className="small-heading-text">
                      (How much time does it take to turn around tables from
                      seating to finish dining)
                    </p>
                  </div>
                </div>
                <div className="col-5 col-sm-5 col-md-6 col-lg-4 col-xl-4 pr-0">
                  <div>
                    <div className="position-relative">
                      <div onClick={reservationTableAroundTimeOpen}>
                        <InputBoxComponent
                          displayLabel={false}
                          controlId="tableturnAroundTime"
                          placeHolder="Select"
                          name="tableturnAroundTime"
                          inputType="text"
                          onChange={onChange}
                          value={state.tableturnAroundTime}
                          required="required"
                          error={errors.tableturnAroundTime}
                          disabled={true}
                          inputClassName={classnames(
                            "input-component-inputfield text-center pr-4",
                            {
                              invalid: errors.tableturnAroundTime,
                            }
                          )}
                        />
                      </div>
                      <p className="small-bottom-text-input-seatingarea">
                        mins
                      </p>
                      <ReservationTimeModel
                        onOpenModal={reservationTableAroundTimeOpen}
                        open={state.reservationTableAroundTime}
                        onCloseModal={reservationTableAroundTimeClosed}
                        buttonTitle="Turn Around Time"
                        buttonText="Turn Around Time"
                        headerText="Turn Around Time"
                        timeTextOne="15 &nbsp;&nbsp; Minutes"
                        timeTextTwo="30 &nbsp;&nbsp; Minutes"
                        timeTextThree="45 &nbsp;&nbsp; Minutes"
                        timeTextFour="60 &nbsp;&nbsp; Minutes"
                        timeTextFive="90 &nbsp;&nbsp; Minutes"
                        timeOneClick={(e) =>
                          reservationTableAroundTimeTextButtonClick(
                            e,
                            "15 Minutes"
                          )
                        }
                        timeTwoClick={(e) =>
                          reservationTableAroundTimeTextButtonClick(
                            e,
                            "30 Minutes"
                          )
                        }
                        timeThreeClick={(e) =>
                          reservationTableAroundTimeTextButtonClick(
                            e,
                            "45 Minutes"
                          )
                        }
                        timeFourClick={(e) =>
                          reservationTableAroundTimeTextButtonClick(
                            e,
                            "60 Minutes"
                          )
                        }
                        timeFiveClick={(e) =>
                          reservationTableAroundTimeTextButtonClick(
                            e,
                            "90 Minutes"
                          )
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="onboarding-map-setup-screen-autodetect-button">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                buttonText="Back"
                onClick={onClickDisplayScreenClosed}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass={
                  (state.seatingCapacity === "" &&
                    state.seatingCapacity.length <= 2) ||
                  (state.autoAcceptPaxLimit === "" &&
                    state.autoAcceptPaxLimit.length <= 2)
                    ? //||
                      // kyc_photo.length <= 0
                      "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                    : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                }
                disabled={
                  (state.seatingCapacity === "" &&
                    state.seatingCapacity.length <= 2) ||
                  (state.autoAcceptPaxLimit === "" &&
                    state.autoAcceptPaxLimit.length <= 2)
                    ? //||
                      // kyc_photo.length <= 0
                      true
                    : false
                }
                buttonText="Next"
                buttonType="button"
                onClick={seatingAreaScreenNext}
              />
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default SeatingArea;
